export function parseDecimal(value: any): number {
  if (value === null || value === undefined) {
    return 0;
  }

  if (typeof value === 'number') {
    return value;
  }

  const normalized = value.toString().trim().replace(',', '.');
  const n = parseFloat(normalized);

  return isNaN(n) ? 0 : n;
}
